
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SummaryViewAllAccountDialog extends SiteEntityDialog<SummaryViewAccountRow, any> {
        protected getFormKey() { return SummaryViewAllAccountForm.formKey; }
        protected getIdProperty() { return SummaryViewAccountRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewAccountRow.localTextPrefix; }
        protected getNameProperty() { return SummaryViewAccountRow.nameProperty; }
        protected getService() { return SummaryViewAccountService.baseUrl; }

        protected form = new SummaryViewAllAccountForm(this.idPrefix);

        protected loadEntity(entity) {
            this.form.InstanceCode.cascadeField = SummaryViewInstanceRow.Fields.ViewCode;
            this.form.InstanceCode.cascadeValue = (entity || {}).InstanceViewCode;

            super.loadEntity(entity);
        }
    }
}